// extracted by mini-css-extract-plugin
export default {"root":"_1NILH","left-aligned":"mZyOx","leftAligned":"mZyOx","right-aligned":"_12aw-","rightAligned":"_12aw-","heading":"_1L6Hh","postfix":"_3uWTG"};